<!-- オーダー > 排出事業者追加 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <Form />
  </v-container>
</template>

<script>

  import Form from './_Form'
  // import BasicForm from './forms/_Basic'

  export default {
    name: 'DriverMasterEmissionNew',
    components: {
      Form,
    },
    mixins: [
    ],
    data () {
      return {
        product: null,
        breadcrumbs: [
          { text: '排出事業者一覧', disabled: false, to: '/driver/masters/emissions', exact: true },
          { text: '排出事業者追加', disabled: true, to: '' },
        ],
        emission: null
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="scss">

</style>
